import { IItemForGetShortInfo, TFileId, IServerError, IUserEmailValidationError, IUpdateUser } from 'types';
import {
	TEditUserFilePath,
	TEditUserSelectedItem,
	TTypeOfEditUserModalWindow,
	TSourceUrlLocally,
	IInitialFormData,
} from './editUserContext';

export enum EditUserActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_FILE = 'SET_FILE',
	DELETE_PHOTO = 'DELETE_PHOTO',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_SURNAME = 'CHANGE_SURNAME',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_PHONE_NUMBER = 'CHANGE_PHONE_NUMBER',
	SET_FETCHED_ROLES = 'SET_FETCHED_ROLES',
	SET_ROLE = 'SET_ROLE',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_CUSTOMERS = 'SET_CUSTOMERS',
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditUserActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditUserActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditUserActionTypes.SET_ALL_DATA;
	payload: {
		filePath: TEditUserFilePath;
		userID: string;
		name: string;
		surName: string;
		email: string;
		phoneNumber: string;
		selectedRole: TEditUserSelectedItem;
		selectedCustomer: TEditUserSelectedItem;
		selectedCustomers: string[];
		initialIDsSelectedRestaurant: string[];
	};
}

interface ISetFile {
	type: EditUserActionTypes.SET_FILE;
	payload: {
		fileId: TFileId;
		sourceUrlLocally: TSourceUrlLocally;
	};
}

interface IDeletePhoto {
	type: EditUserActionTypes.DELETE_PHOTO;
}

interface IChangeName {
	type: EditUserActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface IChangeSurName {
	type: EditUserActionTypes.CHANGE_SURNAME;
	payload: {
		surName: string;
	};
}

interface IChangeEmail {
	type: EditUserActionTypes.CHANGE_EMAIL;
	payload: {
		email: string;
	};
}

interface IChangePhoneNumber {
	type: EditUserActionTypes.CHANGE_PHONE_NUMBER;
	payload: {
		phoneNumber: string;
	};
}

interface ISetFetchedRoles {
	type: EditUserActionTypes.SET_FETCHED_ROLES;
	payload: {
		roles: IItemForGetShortInfo[];
	};
}

interface ISetRole {
	type: EditUserActionTypes.SET_ROLE;
	payload: {
		role: TEditUserSelectedItem;
	};
}

interface ISetFetchedCustomers {
	type: EditUserActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: EditUserActionTypes.SET_CUSTOMER;
	payload: {
		selectedCustomer: TEditUserSelectedItem;
	};
}

interface ISetCustomers {
	type: EditUserActionTypes.SET_CUSTOMERS;
	payload: {
		selectedCustomers: string[];
	};
}

interface ISetFetchedRestaurants {
	type: EditUserActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IItemForGetShortInfo[];
	};
}

interface ISetRestaurants {
	type: EditUserActionTypes.SET_RESTAURANTS;
	payload: {
		selectedRestaurants: string[];
	};
}

interface ISetDataForSubmit {
	type: EditUserActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateUser | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditUserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfEditUserModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: EditUserActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<IUserEmailValidationError> | null;
	};
}

interface IResetSelectedControls {
	type: EditUserActionTypes.RESET_FIELDS;
}

export type TEditUserAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| ISetFile
	| IDeletePhoto
	| IChangeName
	| IChangeSurName
	| IChangeEmail
	| IChangePhoneNumber
	| ISetFetchedRoles
	| ISetRole
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetCustomers
	| ISetFetchedRestaurants
	| ISetRestaurants
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
